import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommunicationsFilter } from '../../../../model';
import { addAllBasicExtraReducers } from '../../../../utils/action-builder-utils';
import { downloadCommunicationDocuments } from './communications-thunks';
import { CommunicationsState } from './communications-types';

const getDefaultFilter = (): CommunicationsFilter => {
  const today = new Date();
  const oneYearAgo = new Date(today);
  oneYearAgo.setFullYear(today.getFullYear() - 1);
  
  return {
    status: [],
    operations: [],
    dividends: [],
    benefits: [],
    other: [],
    rangeDate: {
      from: oneYearAgo,
      to: today
    }
  };
};

const initialState: CommunicationsState = {
  filter: getDefaultFilter(),
  communicationsRequestStatus: 'idle',
};

const communicationsDocumentsSlice = createSlice({
  name: 'features/documents/communications',
  initialState: initialState,
  reducers: {
    clearError(state) {
      state.communicationsError = undefined;
      state.communicationsRequestStatus = 'idle';
    },
    setFilter(state, action: PayloadAction<CommunicationsFilter>) {
      state.filter = action.payload;
    },
    resetFilter(state) {
      state.filter = getDefaultFilter();
    },
    markDocumentAsRead(state, data: PayloadAction<{ id: string }>) {
      const communications = [...state.communications];
      const document = communications.find(
        (item) => item.id === data.payload.id
      );
      document.flagIsRead = true;
      state.communications = communications;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    addAllBasicExtraReducers(
      builder,
      downloadCommunicationDocuments,
      'communications'
    );
  },
});

export const communicationsDocumentsActions =
  communicationsDocumentsSlice.actions;

export default communicationsDocumentsSlice.reducer;
